import React from 'react';
import clsx from 'clsx';

import './index.scss';
const TypeRadio = ({ value, onChange, checked, label}) => {
  return (
    <>
    <span className={clsx('RadioButton', { checked })}>
    <label className='radio-input-wrapper'>
        <input
          className='radio-input'
          type="radio"
          value={value}
          onChange={onChange}
          checked={checked}
        />
        {label}
        </label>
    </span>
    </>
  );

};

export default TypeRadio;